import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { SharedModule } from "../shared/shared.module";
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { InstallationViewAdminComponent } from './installation-view-admin/installation-view-admin.component';
import { InstallationViewClientComponent } from './installation-view-client/installation-view-client.component';
import { InstallationDetailComponent } from './installation-detail/installation-detail.component';
import { installationReducers } from '../stores/global/installations/installation-reducers';
import { deviceReducers } from '../stores/global/devices/device-reducers';
import { DeviceEffets } from '../stores/global/devices/device-effects';
import { InstallationEffets } from '../stores/global/installations/installation-effects';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";


@NgModule({
  declarations: [
    InstallationViewAdminComponent,
    InstallationViewClientComponent,
    InstallationDetailComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    GridModule,
    UploadsModule,
    DateInputsModule,
    SharedModule,
    IndicatorsModule,
    StoreModule.forFeature('installations', installationReducers),
    StoreModule.forFeature('devices', deviceReducers),
    EffectsModule.forFeature([DeviceEffets]),
    EffectsModule.forFeature([InstallationEffets])
  ]
})
export class InstallationModule { }
